import type { Components } from 'react-markdown';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { markdownStyles } from '../utils/markdownStyles';

// Создаем компоненты для ReactMarkdown с поддержкой подсветки синтаксиса
const markdownComponents: Components = {
  // @ts-ignore
  code({ node, inline, className, children, ...props }) {
    const match = /language-(\w+)/.exec(className || '');
    const language = match ? match[1] : '';
    
    return !inline && language ? (
      <SyntaxHighlighter
        language={language}
        style={markdownStyles}
        wrapLines={true}
        wrapLongLines={true}
        customStyle={{ 
          margin: '0.5em 0',
          borderRadius: '4px',
          padding: '8px',
          fontSize: '0.9em'
        }}
      >
        {String(children).replace(/\n$/, '')}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props}>
        {children}
      </code>
    );
  }
};

export default markdownComponents;